export enum Launch_Betsoft {
  "pt" = "pt",
  "es" = "es",
  "hu" = "hu",
}
